export function formateClientsByGroupTree(data) {
    data.forEach(function (item, index) {
        item.supplier_to_business_id = "group" + index;
        item.business_name = item.group_name;
        item.nodeType = 'business_group';
        item.children.forEach(function (leaf) {
            leaf.nodeType = 'business';
        });
    });
    return data;
}
export function initClientsRight(treeDataLevel2, supplier_to_business_ids, group_ids) {
    console.log(333, treeDataLevel2, supplier_to_business_ids);
    treeDataLevel2.forEach(function (v) {
        var chkChildrensNum = 0;
        v.children.forEach(function (leaf) {
            var isChk = supplier_to_business_ids.includes(leaf.supplier_to_business_id);
            leaf.isChk = isChk;
            chkChildrensNum = chkChildrensNum + (isChk ? 1 : 0);
        });
        v.chkChildrensNum = chkChildrensNum;
        if (group_ids !== undefined) {
            v.is_set_group = group_ids.includes(v.group_id) ? 1 : 2;
        }
        if (v.is_set_group && v.chkChildrensNum != v.children.length) {
            v.is_set_group = 2;
        }
    });
    return treeDataLevel2;
}
export function fixBusinessIdsContainGroupNotHasChildren(treeDataLevel2, supplier_to_business_ids, group_ids) {
    var ids = [];
    treeDataLevel2.forEach(function (v) {
        if (v.children.length == 0 && v.is_set_group == 1) {
            ids.push(v.supplier_to_business_id);
        }
    });
    return supplier_to_business_ids.concat(ids);
}
export function checkedTempGroupData(treeDataLevel2) {
    var supplier_to_business_ids = [];
    var group_ids = [];
    treeDataLevel2.forEach(function (v) {
        if (v.is_temp == 1) {
            group_ids.push(v.group_id);
            if (v.children.length) {
                v.children.forEach(function (bus) {
                    supplier_to_business_ids.push(bus.supplier_to_business_id);
                });
            }
        }
    });
    return {
        supplier_to_business_ids: supplier_to_business_ids,
        group_ids: group_ids
    };
}
export function createResultByClientsRight(treeDataLevel2) {
    var supplier_to_business_ids = [];
    var group_ids = [];
    var business_ids = [];
    var business_info = [];
    var business_info_name = [];
    var group_names = [];
    var business_group_names = '';
    var businessList = [];
    treeDataLevel2.forEach(function (v) {
        if (v.chkChildrensNum > 0 || v.children.length == 0) {
            var chkChildrens = v.children.filter(function (leaf) { return leaf.isChk; });
            var chkChildrensIds = chkChildrens.map(function (leaf) { return leaf.supplier_to_business_id; });
            var chkChildrensBusinessIds = chkChildrens.map(function (leaf) { return leaf.business_id; });
            var chkChildrensNames = chkChildrens.map(function (leaf) { return leaf.business_name; });
            business_info.push({
                group_id: v.group_id,
                is_set_group: v.is_set_group,
                children: chkChildrensIds
            });
            if (1 == v.is_set_group) {
                group_ids.push(v.group_id);
                group_names.push(v.business_name);
            }
            supplier_to_business_ids = supplier_to_business_ids.concat(chkChildrensIds);
            business_ids = business_ids.concat(chkChildrensBusinessIds);
            business_info_name = business_info_name.concat(chkChildrensNames);
            var chkChildrensList = chkChildrens.map(function (leaf) {
                return {
                    supplier_to_business_id: leaf.supplier_to_business_id,
                    business_name: leaf.business_name,
                    business_no: leaf.business_no,
                    business_contact: leaf.business_contact,
                    group_name: v.group_name,
                    group_id: v.group_id,
                    is_set_group: v.is_set_group,
                };
            });
            businessList = businessList.concat(chkChildrensList);
        }
    });
    business_group_names = business_info_name.join('、');
    if (group_names.length) {
        var connector = business_group_names.length > 0 ? '、' : '';
        business_group_names = business_group_names + connector + group_names.map(function (v) { return '[' + v + ']'; }).join('、');
    }
    return {
        supplier_to_business_ids: supplier_to_business_ids,
        business_ids: business_ids,
        group_ids: group_ids,
        business_info: business_info,
        business_info_name: business_group_names,
        business_list: businessList,
    };
}
export function tidyDataBusinessInfo(cgTree, supplier_to_business_ids, group_ids) {
    cgTree = formateClientsByGroupTree(cgTree);
    var rightTree = initClientsRight(cgTree, supplier_to_business_ids, group_ids);
    return createResultByClientsRight(rightTree);
}
